{
  "header": "ਸੰਪਤੀ ਦੇ ਵੇਰਵੇ",
  "subtitle": "ਤੁਹਾਡੇ ਟਰੱਕ ਨਾਲ ਜੁੜੀ ਸੰਪਤੀ (ਟ੍ਰੇਲਰ, ਕੰਟੇਨਰ, ਆਦਿ)।",
  "assetType": "ਸੰਪਤੀ ਦੀ ਕਿਸਮ",
  "assetTypePlaceholder": "ਸੰਪਤੀ ਦੀ ਕਿਸਮ ਚੁਣੋ",
  "assetId": "ਸੰਪਤੀ ID (ਜਿਵੇਂ ਕਿ ਟ੍ਰੇਲਰ ਨੰਬਰ)",
  "assetIdPlaceholder": "ਜਿਵੇਂ ਕਿ: ਟ੍ਰੇਲਰ ਨੰਬਰ, ਕੰਟੇਨਰ ID, ਆਦਿ",
  "remove": "ਹਟਾਓ",
  "addAnother": "ਹੋਰ ਸੰਪਤੀ ਸ਼ਾਮਲ ਕਰੋ",
  "trailerType": "ਟ੍ਰੇਲਰ ਦੀ ਕਿਸਮ",
  "trailerId": "ਟ੍ਰੇਲਰ ID"
}
